import { render, staticRenderFns } from "./ViewNivel2.vue?vue&type=template&id=372c2c17&"
import script from "./ViewNivel2.vue?vue&type=script&lang=js&"
export * from "./ViewNivel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports